import { Input } from "@ui-kitten/components";
import { RenderProp } from "@ui-kitten/components/devsupport";
import useOnClickOutside from "hooks/useOnClickOutside";
import React, { forwardRef, useImperativeHandle } from "react";
import { ImageProps, View } from "react-native";

export type AutocompleteRef = {
  clearList: () => void;
  hide: () => void;
  focus: () => void;
};

interface Props {
  placeholder: string;
  value: string;
  onChangeText: (text: string) => void;
  accessoryRight?: RenderProp<Partial<ImageProps>>;
  children?: React.ReactNode;
}
const Autocomplete = forwardRef((props: Props, ref) => {
  const { placeholder, value, onChangeText, accessoryRight, children } = props;

  const listRef = React.useRef(null);
  const inputRef = React.useRef<Input>(null);
  const [listVisible, setListVisible] = React.useState(false);

  const clearList = () => {
    setListVisible(false);
    onChangeText("");
  };

  const hide = () => {
    setListVisible(false);
  };

  const focus = () => {
    inputRef.current?.focus();
  };

  useOnClickOutside(listRef, () => {
    setListVisible(false);
  });

  useImperativeHandle(
    ref,
    () => {
      return {
        clearList,
        hide,
        focus,
      };
    },
    []
  );

  return (
    <View className="relative">
      <Input
        ref={inputRef}
        placeholder={placeholder}
        value={value}
        onChangeText={onChangeText}
        accessoryRight={accessoryRight}
        onFocus={() => {
          setListVisible(true);
        }}
      />
      {listVisible && (
        <View
          className="max-h-96 overflow-y-scroll absolute w-full top-12"
          ref={listRef}
        >
          {children}
        </View>
      )}
    </View>
  );
});

export default Autocomplete;
